<template>
  <v-card>
    <v-card-title>
      {{  $t('claimforms.rights.title') }}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-0">
      <RightsTable
          :items="items"
          :portion-loading="loading"
          :displayed-columns="columns"
          :checkable="false"
          columnSortOrderStore="claimformRightsColumnsOrder"
      >
      </RightsTable>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import Claimform from "@/models/Claimform";
import RightsTable from "@/components/rights/RightsTable";

export default {
  name: "ClaimformRights",
  components: {RightsTable},
  props: {
    item: Claimform,
  },
  data() {
    return {
      items: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters('app', ['currentRightsholder']),
    columns() {
      return [
        'rowNumber',
        'isrc',
        'type',
        'spnr',
        'artistName',
        'title',
        'countryCode',
        'companyCountryCode',
        'secondaryCountryCode',
        'year',
        'revoke',
        'claimStartDate',
        'claimEndDate',
        'labelName',
        'status',
        'version',
        'actions',
      ].concat(this.currentRightsholder.internationalCollectionAllowed ? ['internationalCollection'] : []);
    }
  },
  methods: {
    loadRights() {
      this.loading = true;
      this.$store.dispatch('app/loadClaimformsRows', this.item)
        .then((res) => {
          this.items = res;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    onDeleteRow(row) {

      this.$store.dispatch('app/removeClaimformRow', row)
        .then(() => {
          this.items = this.items.filter((x) => x !== row);
        })
        .catch(() => {
          this.$toast(this.$t('claimforms.rights.removeRow.error'));
        })
    }
  },
  mounted() {
    this.loadRights();
  }
}
</script>